export default __webpack_public_path__ + "static/media/completed.a191e0ef.png";